import "@hotwired/turbo-rails"
import "@shoelace-style/shoelace"
import "trix"
import "@rails/actiontext"
